export default __webpack_public_path__ + "static/media/Eimi.eaddd66b.png";